import { EntitiesStore } from './entities-store.abstract';
import { Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IAthlete } from './athlete-records-store';

/**
 * Detail of indoor team.
 *
 * @export
 * @interface Detail
 */
export interface Detail {
  ID: string;
  Name: string;
  NameShort: string;
  Place: string;
  Country: string;
  Date: string;
  Score: number;
  ScoreDetailed: Array<number>;
  RankDetailed: Array<number>;
  Stage: number;
  inTotal: boolean;
}

/**
 * Model of indoor team.
 *
 * @export
 * @interface ITeamRankingModel
 */
export interface ITeamRankingModel {
  Rnk: number;
  RnkOld: number;
  Cat: string;
  Score: number;
  TeamId: number;
  Name: string;
  Members: IAthlete[];
  Details: Detail[];
  Logo: string;
}

/**
 * Indoor team store.
 *
 * @export
 * @class TeamRankingIndoorStore
 * @extends {EntitiesStore<ITeamRankingModel>}
 */
export class TeamRankingIndoorStore extends EntitiesStore<ITeamRankingModel> {
  constructor(injector: Injector) {
    super('SERIESTEAMSRANKINGS', injector.get(HttpClient));
  }
}
